import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetCategoryNavigationResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.types';
import React from 'react';
import {CategorySlider} from '../../../features/CategorySlider/CategorySlider';
import {useCouponPath} from '../hooks/useCouponPath';
import {CouponLandingPageCategorySliderLoading} from './CouponLandingPageCategorySliderLoading';
import {useCouponLandingPageCategoryNavigation} from './useCouponLandingPageCategoryNavigation';

export const CouponLandingPageCategorySlider = () => {
  return (
    <DataFetcher
      request={useCouponLandingPageCategoryNavigation()}
      Error={null}
      Loading={CouponLandingPageCategorySliderLoading}
      View={CouponLandingPageCategorySliderView}
    />
  );
};

const CouponLandingPageCategorySliderView: React.FC<
  GetCategoryNavigationResponse
> = props => {
  const targetCouponPath = useCouponPath();

  if (!props.categoryNavigation) {
    return null;
  }

  const {selectedCategoryId, categories} = props.categoryNavigation;

  return (
    <CategorySlider
      activeCategoryId={selectedCategoryId}
      categories={categories.map(category => ({
        category,
        hasProducts: true,
        targetPath: targetCouponPath(category.id),
      }))}
    />
  );
};
